var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Descriptive / Payments") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Descriptive-/-Payments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exchange-Box-Line",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,5 L4,19 L20,19 L20,5 L4,5 Z M2.99999991,3 L20.9999999,3 L20.9999999,3 C21.552285,3 21.9999999,3.447715 21.9999999,4 L21.9999999,20 L21.9999999,20 C21.9999999,20.552285 21.552285,21 20.9999999,21 L2.99999991,21 L2.99999991,21 C2.44771491,21 1.99999991,20.552285 1.99999991,20 C1.99999991,20 1.99999991,20 1.99999991,20 L1.99999991,4 L1.99999991,4 C1.99999991,3.44771515 2.44771491,3 2.99999991,3 L2.99999991,3 Z M12,9 L12,6 L17,11 L8,11 L8,9 L12,9 Z M7,13 L16,13 L16,15 L12,15 L12,18 L7,13 Z",
    id: "Shape",
    fillOpacity: 0.64,
    fill: "#191923",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/Payments.67accd061383bae12671282d1c69abf7.svg";
export { ForwardRef as ReactComponent };